import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActiveOrganization } from "../store/userSlice";
import "./OrgSelector.css";

/**
 * Organization Selection Page
 * Shown when user first logs in and has multiple organizations
 */
function OrgSelectionPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const handleSelectOrganization = (membership) => {
    dispatch(
      setActiveOrganization({ organizationId: membership.organization_id })
    );

    // Store selection in localStorage
    localStorage.setItem("activeOrgId", membership.organization_id);

    // Navigate to dashboard
    navigate("/dashboard");
  };

  // If user only has one org, redirect to dashboard
  React.useEffect(() => {
    if (user.memberships && user.memberships.length === 1) {
      navigate("/dashboard");
    }
  }, [user.memberships, navigate]);

  return (
    <div className="org-selector-page">
      <div className="org-selector-container">
        <h1 className="org-selector-title">Select Organization</h1>
        <p className="org-selector-subtitle">
          You belong to multiple organizations. Please select one to continue.
        </p>

        <div className="org-list">
          {user.memberships.map((membership) => (
            <button
              key={membership.organization_id}
              className="org-card"
              onClick={() => handleSelectOrganization(membership)}
            >
              <div className="org-card-content">
                <div className="org-card-name">
                  {membership.organization_name}
                </div>
                <span className="org-card-role">{membership.role}</span>
              </div>
              <div className="org-card-arrow">→</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OrgSelectionPage;
